import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import TemplateComponent from '../components/templates/template.component';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { deepCopy } from '../../../../../common/services/common.service';
import { settings } from '../../../../../redux/settings/actions';
import UploadFiles from '../../../../../models/UploadFile';
import PageLoader from '../../../../../components/PageLoader';


let currentChange: any = {}
const TemplateContainer = ({ onSubmit, cardDetailInfo }: any) => {
  const dispatch = useAppDispatch()
  const parmas: any = useParams()

  const { getUploadFiles } = useAppSelector(selectCurrent)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [
    selectedTemplate,
    setSelectedTemplate
  ] = useState<any>({
    BodyContent: '',
    DesignFileurls: [],
    Attachmenturls: [],
    MappedEntities: []
  })


  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);

  const [
    templateImageIndex,
    setTemplateImageIndex
  ] = useState<any>([])
  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])


  useEffect(
    () => {

      if (cardDetailInfo) {
        setSelectedTemplate(cardDetailInfo)
        const BlogPostItemsData: any = cardDetailInfo?.Attachmenturls?.map((item: any, index: any) => {
          const itemData = {
            Id: index || 0,
            FileTypeId: item?.FileTypeId || 10,
            FileMappingURL: item
          }
          return itemData
        })
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: BlogPostItemsData });
        setMediaFiles(localSelectedMedia)
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    },
    [cardDetailInfo]
  )


  const handleFormAttachmentItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }



  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedTemplate({ ...selectedTemplate, [field]: event });
  }

  const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileMappingURL !== ''
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }

    return localSelectedmedia
  }
  const setCombinationmediaInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileMappingURLDONE'
    setMediaFiles(localSelectedMedia)
  }


  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setTemplateImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'Campaign',
      type: fileType
    })
  }
  const handleSubmit = (data: any) => {
    mediaFiles[templateImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }
  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))

  }

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    selectedTemplate.IsApproved = true;
    mediaFiles?.splice(
      mediaFiles.length - 1,
      1
    )

    const mediaData: any = mediaFiles?.map((item: any) => {
      const itemData = {
        attachementURL: item?.FileMappingURL
      }
      return itemData
    })

    selectedTemplate.Attachmenturls = mediaData.map((data: any) => data.attachementURL);
    onSubmit(selectedTemplate)

  }


  useEffect(
    () => {

    },
    [selectedTemplate]
  )
  useEffect(
    () => {
      if (currentChange.field === 'FileMappingURL') {
        setCombinationmediaInfo()
      }
    },
    [mediaFiles]
  )
  return (
    <>
      {getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleSubmit}
        type={openFile?.type}
        ownerId={parmas?.id}
      />}
      {isLoading ? <PageLoader /> :
        <TemplateComponent
          handleInnerFormChange={handleInnerFormChange}
          handleFormSubmit={handleFormSubmit}
          id={parmas?.id}
          changeImage={changeImage}
          mediaFiles={mediaFiles}
          handleFormAttachmentItemChange={handleFormAttachmentItemChange}
          selectedTemplate={selectedTemplate}
        />}
    </>
  )

}

export default TemplateContainer;